import React from 'react';

import Header from '../../layout/Header.jsx';
import ListTrainings from '../../lists/ListTrainings.jsx';

const PageTrainingsList = () => (
  <div>
    <Header>Trainings</Header>
    <ListTrainings />
  </div>
);

export default PageTrainingsList;
